//import to reducer from action

import { SOCIALFEED_TOTAL_REACTION } from "SocialfeedReactionAction";


export var SocialfeedTotalReaction = (state = {}, action) => {
  
    if (action.type === SOCIALFEED_TOTAL_REACTION) {
      return action.payload;
    }
    return state;
}


